import React from "react";
import "./Contact.scss";
import { useGlobalContext } from "../../../context";
import Info from "./Info/Info";
import SocialNetworks from "./Social-networks/SocialNetworks";
import ContactForm from "./ContactForm/ContactForm";

function Contact() {
  const { showContent, start } = useGlobalContext();

  return (
    <div
      className={`card
    ${start ? "card--active-start" : "card--active"}
    `}
    >
      <div
        className="contact"
        style={{ display: showContent ? "flex" : "none" }}
      >
        <h1 className="contact-header">
          contact<span>.</span>
        </h1>
        <div className="contact-message">
          Have a project in mind or looking for a Frontend Developer?
          Let&apos;s talk.
        </div>
        <div className="contact-body">
          <div className="contact-left">
            <div className="contact-left_info">
              <Info />
            </div>
            <div className="contact-left_social">
              <SocialNetworks />
            </div>
          </div>
          <div className="contact-right">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
